import React, { useState, useEffect, useCallback } from "react";
import { Modal, Typography, TextField } from "@ann/web-components";
import {
  ModalBodyContent,
  MessageText,
  FieldContainer,
  ErrorMessage,
} from "./RemoveUserModal.styled";

const RemoveUserModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName = "",
  isLoading = false,
}) => {
  const [confirmText, setConfirmText] = useState("");

  const handleConfirmTextChange = useCallback((value) => {
    setConfirmText(value);
  }, []);

  const handleClose = useCallback(() => {
    if (!isLoading) {
      setConfirmText("");
      onClose();
    }
  }, [isLoading, onClose]);

  const handleConfirm = useCallback(() => {
    const trimmedConfirm = confirmText.trim();
    const trimmedUserName = userName.trim();

    if (
      trimmedConfirm.toLowerCase() === trimmedUserName.toLowerCase() &&
      !isLoading &&
      onConfirm
    ) {
      onConfirm();
    }
  }, [confirmText, userName, isLoading, onConfirm]);

  // Reset confirm text when modal closes
  useEffect(() => {
    if (!isOpen) {
      setConfirmText("");
    }
  }, [isOpen]);

  const trimmedConfirm = confirmText.trim();
  const trimmedUserName = userName.trim();
  const isConfirmValid =
    trimmedConfirm.toLowerCase() === trimmedUserName.toLowerCase();
  const showError = trimmedConfirm !== "" && !isConfirmValid;
  const canConfirm = isConfirmValid && !isLoading;

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width="571px" size="medium">
      <Modal.Header icon>
        <Modal.Header.Icon name="warning" variant="alert" />
        <Modal.Header.Title>
          <Typography
            category="title"
            size="medium"
            weight="bold"
            color="alert"
          >
            Remove User
          </Typography>
        </Modal.Header.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalBodyContent>
          <MessageText>
            <Typography
              category="body"
              size="medium"
              weight="regular"
              color="body"
            >
              Are you sure you want to remove {userName} from this department?
              This action cannot be undone.
            </Typography>
            <FieldContainer>
              <TextField
                label={`Type a name to confirm`}
                onChange={handleConfirmTextChange}
                size="small"
                placeholder={userName}
                required={true}
                value={confirmText}
                error={showError}
              />
            </FieldContainer>
            {showError && (
              <ErrorMessage>
                Please enter the exact name to confirm
              </ErrorMessage>
            )}
          </MessageText>
        </ModalBodyContent>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button
          label="Cancel"
          onClick={handleClose}
          type="secondary"
          disabled={isLoading}
        />
        <Modal.Button
          label="Remove User"
          onClick={handleConfirm}
          type="error"
          disabled={!canConfirm}
          isLoading={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default RemoveUserModal;
